import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../../auth/services/auth.service';
import { LoaderService } from '../../../../../shared/services/loader.service';
import { RequestsService } from '../../services/requests.service';
import { NotificationService } from '../../../../../shared/services/notification.service';
import { Dependent } from '../../../../user/models/user-profile.model';
import { UserService } from '../../../../user/services/user.service';

@Component({
  selector: 'app-medical-checkup-confirmed',
  imports: [MatIconModule, CommonModule],
  templateUrl: './medical-checkup-confirmed.component.html',
  styleUrl: './medical-checkup-confirmed.component.scss',
})
export class MedicalCheckupConfirmedComponent implements OnInit {
  
  expediente = '';
  fecha = '';
  hora = '';
  expanded = true;
  hideHeaderDiv: boolean = false;
  patientName: string = '';
  description: string = '';//en este campo recibiremos 
  study: string = '';
  laboratory: string = ''
  adress: string = ''
  patient: string = '';
  serviceData: any = null;
  telefono: string = '';
  isBanamex: boolean = false;
  pdfSize: string = '';
  pdfBlob: Blob | null = null;
  user = JSON.parse(localStorage.getItem('user') || '{}');
  dependent: Dependent[] = [];

  // Arrays de estatus
  clEstatus = 0;
  openStatusList = [0, 11, 100, 101, 102, 103, 104, 106, 107, 108];
  closedStatus = [7, 8, 16, 29, 30, 109, 110];
  finishedStatus = [10, 14, 37, 105, 148];

  constructor(
    private router: Router, 
    private authService: AuthService,
    private requestsService: RequestsService,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.checkIfBanamex();
    this.getDetailUser();
    // Intentar obtener datos del estado de navegación actual
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras.state) {
      this.processNavigationState(nav.extras.state);
    } else {
      // Si no hay navegación actual, intentar obtener del historial
      const currentState = history.state;
      if (currentState && Object.keys(currentState).length > 1) {
        this.processNavigationState(currentState);
      }
    }
  }

  processNavigationState(state: any) {
    if (state['fromSelection']) {
      this.hideHeaderDiv = true;
    }
    
    // Obtener datos del servicio si están disponibles
    if (state['serviceResponse']) {
      this.serviceData = state['serviceResponse'];
      this.processServiceData();
    }
    
    // Obtener información del paciente
    this.patient = state['patient'] || '';
    this.patientName = state['patientName'] || '';
  }

  processServiceData() {
    if (this.serviceData) {
      // Procesar expediente
      if (this.serviceData.id) {
        this.expediente = `#${this.serviceData.id}`;
        // Hacer llamada adicional para obtener detalles completos
        this.getExpedienteDetails(this.serviceData.id.toString());
      }
      console.log("servis data",this.serviceData);
      
      // Procesar fecha y hora
      if (this.serviceData.fechaapertura) {
        const fechaCompleta = new Date(this.serviceData.fechaapertura);
        this.fecha = fechaCompleta.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        console.log("hora1 ");
        
        this.hora = this.serviceData.fechaapertura.substring(11, 16);
        
      }
      
      // Procesar teléfono
      if (this.serviceData.telefono1) {
        this.telefono = this.serviceData.telefono1;
      }
    }
  }
  
  getExpedienteDetails(expediente: string) {
    this.loader.show();
    this.requestsService.getAssistanceDetails(expediente).subscribe({
      next: (response) => {
        console.log('Detalles del expediente obtenidos:', response);
        this.clEstatus = response?.data?.data?.clestatus;
        console.log("estatus:", this.clEstatus);
        // Procesar datos adicionales si es necesario
        if (response?.data?.data) {
          const details = response.data.data;
          // Actualizar información adicional si viene en la respuesta
 
          // procesar descripción
          if (details.descripcionocurrido) {
            this.description = details.descripcionocurrido;

            // ejemplo de texto
            const text = details.descripcionocurrido; 
            // "Check-up Médico - Estudio: Biometría hemática - Laboratorio: chopo - Dirección: Calz. México - Tacuba #529 Col. Popotla CP 11400, CDMX"

            const estudioMatch = text.match(/Estudio:\s*([^–-]+)/);
            const laboratorioMatch = text.match(/Laboratorio:\s*([^–-]+)/);
            const direccionMatch = text.match(/Dirección:\s*(.*)$/);

            const estudio = estudioMatch ? estudioMatch[1].trim() : '';
            const laboratorio = laboratorioMatch ? laboratorioMatch[1].trim() : '';
            const direccion = direccionMatch ? direccionMatch[1].trim() : '';

            console.log({ estudio, laboratorio, direccion });

            // puedes asignarlos a propiedades del componente si quieres
            this.study = estudio;
            this.laboratory = laboratorio;
            this.adress = direccion;
          }
        }
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error al obtener detalles del expediente:', error);
        this.loader.hide();
      }
    });
  }

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  checkIfBanamex(): void {
    const allowedAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
    const account = this.authService.getAccount();
    this.isBanamex = account ? allowedAccounts.includes(account) : false;
  }

  private generateFolio(): string {
    const fechaCompleta = new Date(this.serviceData.fechaapertura);
    const año = fechaCompleta.getFullYear().toString().slice(-2);
    const mes = (fechaCompleta.getMonth() + 1).toString().padStart(2, '0');
    const expedienteNum = this.expediente.replace('#', '');
    return `CHUP${año}${mes}${expedienteNum}`;
  }


  private async generatePdfBlob(): Promise<Blob> {
    const ProductByAccount = localStorage.getItem('ProductByAccount');
    const fechaBase = new Date(this.serviceData.fechaapertura);
    const vigenciaDate = new Date(fechaBase);
    vigenciaDate.setDate(fechaBase.getDate() + 60);
    
    const generatePDF = {
      folio: this.generateFolio(),
      cuenta: ProductByAccount ? JSON.parse(ProductByAccount).name : '',
      autorizacion: this.expediente.replace('#', ''),
      fecha: this.fecha,
      medico: 'GERENCIA DE OPERACION MEDICA',
      titular: this.patient === this.user.name,
      beneficiario: this.patient !== this.user.name,
      paciente: this.patientName,
      edad: this.calculateAge(this.getSelectedPatientBirthdate()).toString(),
      nacimiento: this.formatBirthdate(this.getSelectedPatientBirthdate()),
      estudioCheck: true,
      estudio: '- ' + (this.study || ''),
      vigencia: `${vigenciaDate.getDate().toString().padStart(2, '0')}/${(vigenciaDate.getMonth() + 1).toString().padStart(2, '0')}/${vigenciaDate.getFullYear()}`,
      sucursal: this.laboratory + ', ' + this.adress
    };

    const { PdfGenerator } = await import('../generate-pdf/model-pdf');
    return await PdfGenerator.generatePdfAsBlob(generatePDF);
  }

  async downloadPDF() {
    try {
      const blob = await this.generatePdfBlob();
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `checkup-${this.expediente.replace('#', '')}.pdf`;
      link.click();
      
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error generando PDF:', error);
      this.notificationService.showError('Error al generar PDF', 'Error');
    }
  }

  getFormattedPhone(): string {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const phone = user.phone || '';
    if (phone.length >= 10) {
      return `*** **** ${phone.slice(-3)}`;
    }
    return '*** **** ***';
  }

  async resendWhatsApp(): Promise<void> {
    this.loader.show();
    console.log('ENVIAR A WAP');
    
    try {
      const blob = await this.generatePdfBlob();
      const base64 = await this.blobToBase64(blob);
      this.sendCheckupWA(base64, this.expediente.replace('#', ''));
    } catch (error) {
      console.error('Error generando PDF para WhatsApp:', error);
      this.loader.hide();
      this.notificationService.showError('Error al generar PDF', 'Error');
    }
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        // Remover el prefijo "data:application/pdf;base64,"
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }


  private sendCheckupWA(base64Pdf: string, expediente: string): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const phoneNumber = user.phone || '';

    const payload = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "13"
      },
      petition: {
        phoneNumber: parseInt(phoneNumber),
        templateId: 54,
        mediaBase64: base64Pdf,
        mediaType: "document",
        mediaName: `checkup-${expediente}.pdf`
      }
    };

    this.requestsService.sendCheckupWA(payload).subscribe({
      next: (response) => {
        this.loader.hide();
        this.notificationService.showSuccess('Documento reenviado exitosamente por WhatsApp', 'Éxito');
      },
      error: (error) => {
        console.error('Error al enviar PDF por WhatsApp:', error);
        this.loader.hide();
        this.notificationService.showError('Error al reenviar por WhatsApp', 'Error');
      }
    });
  }

  getStatusClass(clEstatus: any): string {
    const status = parseInt(clEstatus);
    
    if (this.closedStatus.includes(status)) {
      return 'status-finished';
    }
    
    if (this.finishedStatus.includes(status)) {
      return 'status-concluded';
    }
    
    return 'status-open';
  }

  getStatusDisplay(clEstatus: any): string {
    const status = parseInt(clEstatus);
    
    if (this.openStatusList.includes(status)) {
      return 'Abierto';
    }
    else if (this.closedStatus.includes(status)) {
      return 'Cancelado';
    }
    
    else if (this.finishedStatus.includes(status)) {
      return 'Concluido';
    }
    
    return 'Abierto';
  }

  
  private getSelectedPatientBirthdate(): string {
    if (this.patient === this.user.name) {
      return this.user.birthdate || '';
    } else {
      const selectedDependent = this.dependent.find(dep => dep.name === this.patientName);
      return selectedDependent?.birthdate || this.user.birthdate || '';
    }
  }

  private formatBirthdate(birthdate: string): string {
    if (!birthdate) return '01/01/1990';
    
    try {
      const date = new Date(birthdate);
      if (isNaN(date.getTime())) return '01/01/1990';
      
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      
      return `${day}/${month}/${year}`;
    } catch (error) {
      return '01/01/1990';
    }
  }

  private calculateAge(birthdate: string): number {
    if (!birthdate) return 25;
    
    try {
      const birth = new Date(birthdate);
      const today = new Date();
      
      if (isNaN(birth.getTime())) return 25;
      
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      
      return age > 0 ? age : 25;
    } catch (error) {
      return 25;
    }
  }

}